import { createContext } from 'react';

const DRMModifiersContext = createContext({});

export default DRMModifiersContext;
